import { CallbackParams } from '../../models';
import { GithubAuthDataService } from '../github-auth-data.service';
import { LocationService } from '../location.service';
import { GithubAuthRequest } from './github-auth-request';
import { Injectable } from '@angular/core';
import { ClientEnvironment, GithubAuthData } from '@jukebox/common';
import { EnvConfigService } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class GithubAuthService {
  constructor(
    private envConfigService: EnvConfigService,
    private locationService: LocationService,
    private githubAuthDataService: GithubAuthDataService,
  ) {}

  /**
   * executes a GitHub auth flow.
   * The return value indicates, if a redirect has happened.
   * True means the site gets unloaded soon
   */
  public async executeGithubAuthFlowIfRequired(domain: string): Promise<void> {
    const envConfig: ClientEnvironment =
      (await this.envConfigService.getEnvConfig()) as any as ClientEnvironment;
    const githubSetting = envConfig.githubSettings[domain];
    const githubTokenEnabled =
      domain && githubSetting && githubSetting.githubClientId;

    if (githubTokenEnabled) {
      await this.executeAuthFlow(domain, githubSetting.githubClientId);
    }
    return;
  }

  private executeAuthFlow = async (
    githubDomain: string,
    githubClientId: string,
  ): Promise<GithubAuthData | undefined> => {
    const authData =
      this.githubAuthDataService.getGithubAuthDataForDomain(githubDomain);
    const accessToken = authData?.access_token;

    if (accessToken) {
      return Promise.resolve(authData);
    }

    const githubCallbackUrl = new URL(window.location.origin);
    const stateData: CallbackParams = {
      url: window.location.href,
      domain: githubDomain,
    };
    githubCallbackUrl.pathname = 'github';

    const authFlow = new GithubAuthRequest(githubDomain, githubClientId);
    authFlow.stateParameter = encodeURIComponent(JSON.stringify(stateData));
    authFlow.redirectUriParameter = githubCallbackUrl.href;

    await this.locationService.openAuthWindow(authFlow.getAuthFlowUrl());
  };
}
